import React, { useState } from 'react';
import { Text, Flex } from 'rebass';
import * as Yup from 'yup';

import { ErrorMessageWrap, Label, TextFieldWrap } from 'app/form/formik/text/styled';
import { keyframes } from '@emotion/react';
import { IoIosArrowRoundBack } from "react-icons/io";
import DesignGiftCertificate from './DesignGiftCertificate';
import OrderComposer from './OrderComposer';

const rotate = keyframes`
  0% { transform: translateY(0); }
  100% { transform: translateY(10px);  }
`;

function splitPrice(price) {
    const wholePart = Math.floor(price);
    const decimalPart = (price % 1).toFixed(2).slice(1);
    return { wholePart, decimalPart };
}

const TextInput = React.forwardRef(({ error, value, onChange, title, defaultValue, placeholder, onBlur, ...props }, ref) => {
    return <TextFieldWrap  {...props} my={2} error={!!error} sx={{
        borderColor: '#D9D9D9',
        //  cursor: disabled && 'not-allowed',
        borderRadius: '31px'
    }} >
        <Label >{title}</Label>
        <input
            ref={ref}
            placeholder={placeholder}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="off"
            style={{ width: '100%', fontSize: 16, height: 42, padding: '10px', borderRadius: 31 }}
        />
        {error && (
            <ErrorMessageWrap maxWidth={290} fontSize={16}>
                {error}
            </ErrorMessageWrap>
        )}
    </TextFieldWrap>
})

const schema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email address')  // Built-in email validation
        .required('Email is required'),   // Make the email field required
});
const GiftCertificateReview = React.forwardRef(({ calculatedPricing, quantity, setRequiresQuantity, email, setEmail, onStepDown,
    name_of_recipient,
    setNameOfRecipient,
    name_of_giver,
    setNameOfGiver,
    currentChildJournalId,
    setGiftCertificateStyleId,
    gift_certificate_style_id,
    firePostMemberEvent,
    orderSummary,
}, ref) => {
    const [error, setError] = useState({})
    return <Flex flexDirection="column" m="auto" maxWidth={700} mb={3} mt={4}>

        {onStepDown && <IoIosArrowRoundBack size={30} style={{ cursor: 'pointer' }} onClick={onStepDown} />}

        <Flex mb={2} flexDirection="column" justifyContent="center" alignItems="center">
            <Text
                margin="auto"
                bg="#3B332B"
                sx={{
                    borderRadius: '7px 7px 11px 7px',
                    p: '12px',
                }}
                color="#FFF"
                fontFamily="Poppins"
                fontSize="14px"
                fontStyle="normal"
                fontWeight={400}
                lineHeight="100%"
                letterSpacing="-0.28px"
            >Special offer
            </Text>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="5" viewBox="0 0 13 5" fill="none">
                <path d="M5.1726 4.45198L0.0625 0H12.0625L6.45352 4.47939C6.07599 4.78089 5.53689 4.76936 5.1726 4.45198Z" fill="#3B332B" />
            </svg>
        </Flex>
        <Text
            color="codGrey"
            fontFamily="Bitter"
            fontSize={[22, 28]}
            fontWeight={600}
            lineHeight="100%"
            letterSpacing="-0.168px"
            textAlign="center"
        >
            Baby Year Books
        </Text>
        {!currentChildJournalId && <Text
            color="mineShaft"
            fontFamily="Bitter"
            fontSize={[14, 18]}
            fontWeight={500}
            lineHeight="100%"
            letterSpacing="-0.36px"
            textAlign="center"
            mt={1}
        >
            Gift certificate
        </Text>}
        <Flex flexDirection="column" alignItems="center" >

            <Flex mt={2} alignItems="center" p={1}
                sx={{
                    borderRadius: '60px',
                    background: 'linear-gradient(90deg, #F3E8FF 0%, #FCE7F3 100%)'
                }}>
                <Text
                    color="#34495E"
                    fontFamily="Poppins"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="24px"
                    letterSpacing="-0.32px"
                    mr={2}
                    sx={{
                        textDecorationLine: 'line-through',
                    }}
                >
                    ${calculatedPricing?.totalAmount}
                </Text>
                <Text
                    mr={2}
                    color="#34495E"
                    fontFamily="Poppins"
                    fontSize="16px"
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="24px"
                    letterSpacing="-0.32px"
                    sx={{
                        textDecorationLine: 'line-through',
                    }}
                >
                    ${calculatedPricing?.secondPrice}
                </Text>
                <Flex alignItems="center">
                    <Text
                        color="mineShaft"
                        fontFamily="Bitter"
                        fontSize="30px"
                        fontStyle="normal"
                        fontWeight={600}
                        lineHeight="100%"
                        letterSpacing="-0.6px"
                        mr={1}
                    >
                        $<Text as="span" sx={{ verticalAlign: 'bottom' }}>{splitPrice(calculatedPricing?.finalPrice).wholePart}</Text><Text as="span" sx={{
                            fontSize: '12px',
                            verticalAlign: 'super',
                            position: 'relative',
                            top: '-8px'
                        }}>{splitPrice(calculatedPricing?.finalPrice).decimalPart}</Text>

                    </Text>
                </Flex>
            </Flex>
        </Flex>
        {!currentChildJournalId && <Text
            my={4}
            color="#34495E"
            fontSize={15}
            fontFamily="Poppins"
            lineHeight="150%"
            fontWeight={400}
            letterSpacing="-0.3px"
            textAlign="center"
        >
            Each gift certificate unlocks a full year app subscription and a stunning baby book for your loved one. Help them create a keepsake they’ll treasure forever.
        </Text>}
        {!currentChildJournalId && <DesignGiftCertificate
            email={email}
            setEmail={setEmail}
            name_of_recipient={name_of_recipient}
            setNameOfRecipient={setNameOfRecipient}
            name_of_giver={name_of_giver}
            setNameOfGiver={setNameOfGiver}
            setGiftCertificateStyleId={setGiftCertificateStyleId}
            gift_certificate_style_id={gift_certificate_style_id}
        />}
        <OrderComposer
            calculatedPricing={calculatedPricing}
            quantity={quantity}
            setRequiresQuantity={setRequiresQuantity}
            orderSummary={orderSummary}
            firePostMemberEvent={firePostMemberEvent}
        />
        <Text
            color="mineShaft"
            fontFamily="Poppins"
            fontSize="15px"
            fontStyle="italic"
            fontWeight={400}
            lineHeight="150%"
            letterSpacing="-0.3px"
            mt={4}
        >
            *Prices in USD.  Subscription will auto-renew. Cancel anytime; your plan will continue until the end of your subscription. Shipping included in the US and Canada.
        </Text>
    </Flex >
})

export default GiftCertificateReview;